import { PLAYER_TYPE, VideoMetadata, DownloadSongMetadata } from 'shared-types/video-metadata';

// return licence token and url from songs metatadas for MP3 files with voices
export const waitingListDownloadWithVoices = (
  waitingList: VideoMetadata[],
): DownloadSongMetadata[] =>
  waitingList.map((waitingListSongMetadata: VideoMetadata) => {
    if (
      waitingListSongMetadata.playerType === PLAYER_TYPE.MP3_KBP &&
      waitingListSongMetadata.isVocalGuideAvailable
    ) {
      return {
        licenseToken: waitingListSongMetadata.instrumentalWithVoicesLicenseToken,
        videoUrl: waitingListSongMetadata.instrumentalWithVoicesFileUrl,
      };
    }
    return initialDownloadSongMetada;
  });

// return licence token and url from songs metatadas for MP4/MP3 instrumentals
export const waitingListDownloadInstrumental = (
  waitingList: VideoMetadata[],
): DownloadSongMetadata[] =>
  waitingList.map((waitingListSongMetadata: VideoMetadata) => {
    return {
      licenseToken: waitingListSongMetadata.licenseToken,
      videoUrl: waitingListSongMetadata.videoUrl,
    };
  });

export const initialDownloadSongMetada = {
  licenseToken: '',
  videoUrl: '',
};
